import styled from 'styled-components';

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  animation: fadeIn 0.5s ease-in-out;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const SuccessIcon = styled.div`
  width: 80px;
  height: 80px;
  background: ${({ theme }) => theme.colors.primary.light}20; /* 20% opacity */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.primary.main};

  svg {
    width: 40px;
    height: 40px;
  }
`;

export const SuccessTitle = styled.h2`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.gray[900]};
  margin-bottom: 16px;
`;

export const SuccessMessage = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.gray[200]}; /* Using gray.200 might be too light for text, let's check theme */
  color: #666; /* Fallback/Manual override for better readability */
  line-height: 1.5;
  margin-bottom: 32px;
  max-width: 400px;
`;
